import { Box } from "@chakra-ui/react";

export default function SvgContainer({
  fill,
  icon: Icon,
  size,
  width,
  height,
  ...rest
}) {
  if (size) {
    width = size;
    height = size;
  }
  if (height == null) {
    height = width;
  }
  return (
    <Box
      width={width}
      height={height}
      {...rest}
      sx={
        fill
          ? {
              "& > svg > path, & > svg > g > path": {
                fill
              }
            }
          : undefined
      }
    >
      {width ? <Icon width="100%" height="100%" /> : <Icon />}
    </Box>
  );
}
